export default __webpack_public_path__ + "static/media/banner-reaction-12.4897d4b7.png";